module.exports = __webpack_public_path__ + "static/media/proifle-icon-bg.2a2676a4.png";